const lengthPass = (value) => /^.{8,32}$/.test(value)
const hasNum = (value) => /\d+/.test(value)
const hasLcLetter = (value) => /[a-z]/.test(value)
const hasPuLetter = (value) => /[A-Z]/.test(value)
const hasSpecial = (value) =>
  /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/.test(value)

const verifyPass = (v) => {
  return [lengthPass(v), hasNum(v), hasLcLetter(v), hasPuLetter(v), hasSpecial(v)].every(e => e)
}

export default { lengthPass, hasNum, hasLcLetter, hasPuLetter, hasSpecial, verifyPass }
